interface MapImageProps {
  address: string;
  staticImageUrl: string;
  googleLink: string;
  className?: string;
  height?: number | string;
}

export function MapImage({ 
  address, 
  staticImageUrl, 
  googleLink,
  className = '',
  height = 360
}: MapImageProps) {
  return (
    <div className={className}>
      <div className="w-full overflow-hidden rounded-xl border border-black/10 shadow-sm">
        <img
          src={staticImageUrl}
          alt={`Mapa de ${address}`}
          className="w-full object-cover rounded-xl"
          style={{ height: typeof height === 'number' ? `${height}px` : height }}
          loading="lazy"
        />
      </div>
      <div className="mt-2 text-sm">
        <a
          href={googleLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm underline hover:opacity-80 flex items-center gap-1"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="14" 
            height="14" 
            fill="currentColor" 
            viewBox="0 0 16 16"
            className="flex-shrink-0"
          >
            <path d="M8 0a5 5 0 0 0-5 5c0 3.5 5 10.5 5 10.5S13 8.5 13 5a5 5 0 0 0-5-5Zm0 7.5A2.5 2.5 0 1 1 8 2.5a2.5 2.5 0 0 1 0 5Z"/>
          </svg>
          Ver en Google Maps
        </a>
      </div>
    </div>
  );
}
